import slice from "lodash/slice";

function getPageItems(list, page, pageSize) {
  return slice(list, (page - 1) * pageSize, page * pageSize);
}

export default getPageItems;
